import React from "react";
import PropTypes from "prop-types";
const ResizeIconSmall = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M-1114-218H252v768h-1366z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"} fillRule="nonzero">
        <path d="M3.564 2c-.662 0-.864.039-1.07.149a.818.818 0 0 0-.345.346C2.039 2.7 2 2.902 2 3.564v8.872c0 .662.039.864.149 1.07a.818.818 0 0 0 .346.345c.205.11.407.149 1.069.149h8.872c.662 0 .864-.039 1.07-.149a.818.818 0 0 0 .345-.346c.11-.205.149-.407.149-1.069V3.564c0-.662-.039-.864-.149-1.07a.818.818 0 0 0-.346-.345C13.3 2.039 13.098 2 12.436 2H3.564zm0-2h8.872c.964 0 1.477.1 2.012.385.5.268.9.666 1.167 1.167C15.9 2.087 16 2.6 16 3.564v8.872c0 .964-.1 1.477-.385 2.012-.268.5-.666.9-1.167 1.167-.535.286-1.048.385-2.012.385H3.564c-.964 0-1.477-.1-2.012-.385a2.817 2.817 0 0 1-1.167-1.167C.1 13.913 0 13.4 0 12.436V3.564C0 2.6.1 2.087.385 1.552c.268-.5.666-.9 1.167-1.167C2.087.1 2.6 0 3.564 0z" />
        <path d="M10.564 9c-.662 0-.864.039-1.07.149a.818.818 0 0 0-.345.346C9.039 9.7 9 9.902 9 10.564V14h3.436c.662 0 .864-.039 1.07-.149a.818.818 0 0 0 .345-.346c.11-.205.149-.407.149-1.069V9h-3.436zm0-2H15a1 1 0 0 1 1 1v4.436c0 .964-.1 1.477-.385 2.012-.268.5-.666.9-1.167 1.167-.535.286-1.048.385-2.012.385H8a1 1 0 0 1-1-1v-4.436c0-.964.1-1.477.385-2.012.268-.5.666-.9 1.167-1.167C9.087 7.1 9.6 7 10.564 7z" />
      </g>
    </g>
  </svg>
);
ResizeIconSmall.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default ResizeIconSmall;
